<template>
    <div class="js-loader">
        <SVGSprite name="loading" />
    </div>
</template>

<script>
export default {
    name: 'PageLoader'
};
</script>

<style lang="scss">
.js-loader {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: none;

    .svg-sprite {
        width: 4rem;

        svg {
            path {
                fill: theme-color('primary');
            }
        }
    }
}
</style>
